export enum TaskPlanSectionType {
  Optional = 0,
  Mandatory,
  Default,
  Multiple,
}
